// Detects the low-power TV player mode. The Fire TV / Android TV WebView loads
// the page with ?player=android_tv; ?lite=1 (or ?lite=true) forces it on for
// testing in a desktop browser. In this mode the boards shed GPU-expensive
// effects and auto-unlock audio (a D-pad remote can't tap a web overlay).
const _p = new URLSearchParams(window.location.search);
export const LITE =
  _p.get('player') === 'android_tv' ||
  _p.get('lite') === '1' ||
  _p.get('lite') === 'true';
